module.exports = __webpack_public_path__ + "static/media/baseAlt.1b6dcde8.jpg";